import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Balance({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 16 14" fill="currentColor">
      <path d="M16,8.54a.85.85,0,0,0,0-.23L13.21,1.85a.6.6,0,0,0-.58-.38h-3a1.73,1.73,0,0,0-3.24,0h-3a.6.6,0,0,0-.58.38L.05,8.31a.85.85,0,0,0,0,.23,3.38,3.38,0,1,0,6.73.54,2.44,2.44,0,0,0,0-.54.59.59,0,0,0,0-.23L4.34,2.75H6.39a1.74,1.74,0,0,0,1,1V14H8.64V3.7a1.74,1.74,0,0,0,1-1h2.05L9.3,8.31a.59.59,0,0,0,0,.23A3.38,3.38,0,1,0,16,9.08,4.86,4.86,0,0,0,16,8.54ZM5.15,7.91H1.6L3.37,3.74Zm5.7,0,1.78-4.17L14.4,7.91Z" />
    </SvgIcon>
  )
}
